<div
  class="fgbcl-game-answer-type-text-section"
  [ngClass]="{ 'fgbcl-predictor': groupType == groupTypes.Predictor, 'fgbcl-trivia': groupType == groupTypes.Trivia }"
>
  <div
    class="fgbcl-game-answer-type-text-container"
    *ngFor="let answer of answers"
    (click)="onAnswerSelected(answer)"
    [ngClass]="{
      'fgbcl-game-selected-correct-answer': groupType == groupTypes.Trivia && answer.UserSelected && answer.IsCorrect && !loading,
      'fgbcl-game-selected-incorrect-answer':
        groupType == groupTypes.Trivia && answer.UserSelected && !answer.IsCorrect && !loading,
      'fgbcl-game-correct-answer': groupType == groupTypes.Trivia && answer.IsCorrect && !answer.UserSelected,
      'fgbcl-game-no-selected-answer-overlay':
        selectedAnswer &&
        ((groupType == groupTypes.Trivia && !answer.UserSelected && !answer.IsCorrect) ||
          (groupType === groupTypes.Predictor && selectedAnswer.Id !== answer.Id)),
      'fgbcl-game-selected-answer':
        (groupType === groupTypes.Predictor || groupType === groupTypes.Poll) && selectedAnswer && selectedAnswer.Id == answer.Id,
    }"
  >
    <div class="fgbcl-game-answer-text">
      {{ answer.Title }}
      <span class="fgbcl-game-answer-text-status-label" *ngIf="groupType == groupTypes.Trivia && answer.IsCorrect && !loading">{{
        'fgbcl.game.correct.answer.text' | translate
      }}</span>
      <span
        class="fgbcl-game-answer-text-status-label"
        *ngIf="groupType == groupTypes.Trivia && answer.UserSelected && !answer.IsCorrect && !loading"
        >{{ 'fgbcl.game.incorrect.answer.text' | translate }}</span
      >
    </div>
  </div>
</div>
